import { type ISocketOrderEvent } from '@/types/ISocketOrderEvent';
import { getOrderSequence } from './getOrderSequence';

/**
 * Определяет, является ли событие `candidate` более новым, чем `current`.
 * Сокеты могут приходить не по порядку, поэтому порядок определяем по
 * `datetime`, а при равном `datetime` — по порядковому номеру заказа (больший
 * новее), а при равном номере — по `uuid`. Дубликаты (то же время и тот же
 * заказ) новее не считаются.
 *
 * Порядковый номер — хвост `formated_id` (`getOrderSequence`): до PAR-5189 здесь
 * сравнивался `data.id`, которого в событии больше нет. `uuid` в последней
 * ступени смысла «новее» не несёт, но делает порядок детерминированным для
 * заказов без номера.
 *
 * @param candidate - проверяемое событие
 * @param current - последнее уже обработанное событие (или `null`, если его ещё нет)
 * @returns `true`, если `candidate` нужно применить как более новое
 */
export const isNewerOrderEvent = (
  candidate: ISocketOrderEvent,
  current: ISocketOrderEvent | null
): boolean => {
  if (current === null) {
    return true;
  }

  if (candidate.datetime !== current.datetime) {
    return candidate.datetime > current.datetime;
  }

  const bySequence =
    getOrderSequence(candidate.data) - getOrderSequence(current.data);

  if (bySequence !== 0) {
    return bySequence > 0;
  }

  return candidate.data.uuid > current.data.uuid;
};
